const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485566"
    },
    d: "M456.348,267.13H356.174c-4.429,0-8.674-1.761-11.804-4.892l-50.087-50.087 c-3.135-3.135-4.896-7.386-4.892-11.821s1.772-8.685,4.913-11.815l26.489-26.38c9.381-9.462,21.967-14.712,35.375-14.718 c13.402,0,25.994,5.256,35.456,14.793l76.522,76.407c4.777,4.772,6.212,11.956,3.631,18.202 C469.19,263.06,463.103,267.13,456.348,267.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#576573"
    },
    d: "M155.826,267.13H55.652c-6.755,0-12.842-4.07-15.429-10.31c-2.581-6.244-1.146-13.429,3.631-18.202 l76.576-76.467c9.396-9.479,21.984-14.728,35.391-14.733c13.402,0,25.994,5.256,35.456,14.793l26.418,26.305 c3.141,3.131,4.907,7.381,4.913,11.815s-1.755,8.685-4.892,11.821l-50.087,50.087C164.5,265.37,160.255,267.13,155.826,267.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607080"
    },
    d: "M367.972,238.637l-76.466-76.466c-9.572-9.461-22.15-14.803-35.506-14.803 c-13.468,0.111-26.045,5.343-35.395,14.803l-14.692,14.581l-61.885,61.885c-4.786,4.786-6.233,11.91-3.673,18.143 c2.671,6.233,8.682,10.351,15.471,10.351h200.348c6.79,0,12.8-4.118,15.471-10.351C374.205,250.546,372.758,243.423,367.972,238.637 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#576573"
    },
    d: "M371.645,256.779c-2.671,6.233-8.682,10.351-15.471,10.351H256V147.367 c13.357,0,25.934,5.343,35.506,14.803l76.466,76.466C372.758,243.423,374.205,250.546,371.645,256.779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8C9D9"
    },
    d: "M394.685,478.609H372.87c-9.223,0-16.696-7.473-16.696-16.696c0-9.206-7.49-16.696-16.696-16.696 c-9.206,0-16.696,7.49-16.696,16.696c0,9.223-7.473,16.696-16.696,16.696H205.913c-9.223,0-16.696-7.473-16.696-16.696 c0-9.206-7.49-16.696-16.696-16.696s-16.696,7.49-16.696,16.696c0,9.223-7.473,16.696-16.696,16.696h-21.816 c-24.603,0-45.385-17.57-49.414-41.777L54.853,353.18c-0.756-4.815,0.641-9.722,3.81-13.429c3.174-3.706,7.81-5.837,12.684-5.837 h369.304c4.875,0,9.511,2.13,12.684,5.837c3.169,3.706,4.566,8.614,3.81,13.429l-13.022,83.478 C440.071,461.038,419.288,478.609,394.685,478.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9EACBA"
    },
    d: "M440.652,333.913H256v144.696h50.087c9.223,0,16.696-7.473,16.696-16.696 c0-9.206,7.49-16.696,16.696-16.696c9.206,0,16.696,7.49,16.696,16.696c0,9.223,7.473,16.696,16.696,16.696h21.816 c24.603,0,45.385-17.57,49.44-41.951l13.022-83.478c0.756-4.815-0.641-9.722-3.81-13.429 C450.163,336.043,445.527,333.913,440.652,333.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#576573"
    },
    d: "M339.478,512c-27.619,0-50.087-22.468-50.087-50.087s22.468-50.087,50.087-50.087 s50.087,22.468,50.087,50.087S367.097,512,339.478,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485566"
    },
    d: "M389.565,461.913c0-27.619-22.468-50.087-50.087-50.087V512 C367.097,512,389.565,489.532,389.565,461.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#576573"
    },
    d: "M172.522,512c-27.619,0-50.087-22.468-50.087-50.087s22.468-50.087,50.087-50.087 s50.087,22.468,50.087,50.087S200.141,512,172.522,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#485566"
    },
    d: "M222.609,461.913c0-27.619-22.468-50.087-50.087-50.087V512 C200.141,512,222.609,489.532,222.609,461.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7EBFF"
    },
    d: "M172.522,478.609c-9.206,0-16.696-7.49-16.696-16.696c0-9.206,7.49-16.696,16.696-16.696 s16.696,7.49,16.696,16.696C189.217,471.119,181.728,478.609,172.522,478.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDDEFF"
    },
    d: "M189.217,461.913c0-9.206-7.49-16.696-16.696-16.696v33.391 C181.728,478.609,189.217,471.119,189.217,461.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7EBFF"
    },
    d: "M339.478,478.609c-9.206,0-16.696-7.49-16.696-16.696c0-9.206,7.49-16.696,16.696-16.696 c9.206,0,16.696,7.49,16.696,16.696C356.174,471.119,348.684,478.609,339.478,478.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDDEFF"
    },
    d: "M356.174,461.913c0-9.206-7.49-16.696-16.696-16.696v33.391 C348.684,478.609,356.174,471.119,356.174,461.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15D"
    },
    d: "M472.842,253.021l-17.906,114.283H57.064L39.158,253.021H472.842z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9B54C"
    },
    points: "256,253.021 256,367.304 454.936,367.304 472.842,253.021 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8C9D9"
    },
    d: "M489.739,267.13H22.261c-9.22,0-16.696-7.475-16.696-16.696l0,0c0-9.22,7.475-16.696,16.696-16.696 h467.478c9.22,0,16.696,7.475,16.696,16.696l0,0C506.435,259.655,498.96,267.13,489.739,267.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9EACBA"
    },
    d: "M489.739,233.739H256v33.391h233.739c9.22,0,16.696-7.475,16.696-16.696 S498.96,233.739,489.739,233.739z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#607080"
    },
    cx: 222.631,
    cy: 95.009,
    r: 16.696
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#485566"
    },
    cx: 389.587,
    cy: 95.009,
    r: 16.696
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607080"
    },
    d: "M349.384,48.863l-39.402,39.29c-1.002,1.113-2.449,1.67-3.896,1.67s-2.783-0.557-3.896-1.558 c-8.904-8.904-30.499-30.609-39.402-39.402c-2.226-2.226-2.115-5.677,0-7.903l39.402-39.29C303.193,0.557,304.64,0,306.087,0 s2.894,0.557,4.007,1.67l39.29,39.29C351.61,43.186,351.61,46.637,349.384,48.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#576573"
    },
    d: "M349.384,48.863l-39.402,39.29c-1.002,1.113-2.449,1.67-3.896,1.67V0c1.447,0,2.894,0.557,4.007,1.67 l39.29,39.29C351.61,43.186,351.61,46.637,349.384,48.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607080"
    },
    d: "M182.428,48.863l-39.402,39.29c-1.002,1.113-2.449,1.67-3.896,1.67s-2.783-0.557-3.896-1.558 c-8.904-8.904-30.498-30.609-39.402-39.402c-2.226-2.226-2.115-5.677,0-7.903l39.402-39.29C136.237,0.557,137.683,0,139.13,0 s2.894,0.557,4.007,1.67l39.29,39.29C184.654,43.186,184.654,46.637,182.428,48.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#576573"
    },
    d: "M182.428,48.863l-39.402,39.29c-1.002,1.113-2.449,1.67-3.896,1.67V0c1.447,0,2.894,0.557,4.007,1.67 l39.29,39.29C184.654,43.186,184.654,46.637,182.428,48.863z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoal);
export default __webpack_public_path__ + "static/media/Coal.25fc1263ebc94d959d09fbce9a9aeb21.svg";
export { ForwardRef as ReactComponent };